module.exports = __webpack_public_path__ + "static/media/FlowBasic.72f388da.png";